import React from "react";
import Hero from "../components/Hero";

export default function Home() {
  return (
    <div className="relative">
      <Hero />
      {/* Add any sections below the hero as you grow the page */}
    </div>
  );
}
